var _circle, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMixAndMatch = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 22.35,
  cy: 22.95,
  r: 4.4,
  stroke: "#231F20",
  strokeWidth: 1.7
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 5.35,
  y: 4.85,
  width: 8.3,
  height: 9.3,
  rx: 2.15,
  stroke: "#000",
  strokeWidth: 1.7
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M18 5h2a3 3 0 0 1 3 3v5m3-2.5L23 13l-3-2.5M14 27h-2a3 3 0 0 1-3-3v-5m-3 2.5L9 19l3 2.5",
  stroke: "#000",
  strokeWidth: 1.7
})));
export default SvgMixAndMatch;